import React from 'react';
import { node, oneOf } from 'prop-types';

import { textOverflow } from './config';
import { AutoScroll } from './styles';

const AutoScrollWrapper = ({ children, overflow }) => {
  switch (overflow) {
    case 'auto-scroll':
      return <AutoScroll>{children}</AutoScroll>;
    default:
      return children;
  }
};

AutoScrollWrapper.propTypes = {
  children: node,
  overflow: oneOf(Object.keys(textOverflow)),
};

AutoScrollWrapper.defaultProps = {
  children: null,
  overflow: 'nowrap',
};

export default AutoScrollWrapper;
